import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'adminapp-upload-keymap-file',
  templateUrl: './upload-keymap-file.component.html',
  styleUrls: ['./upload-keymap-file.component.scss']
})
export class UploadKeymapFileComponent implements OnInit {

  @Input()
  selectFile = '';
  @Input()
  preChange: Function;
  @Input()
  disabled: boolean;
  @Output()
  file: EventEmitter<File> = new EventEmitter<File>();
  @Output()
  errorEventEmitter: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('keymapFile') fileUploadInput;
  @ViewChild('browseKeymapFile') browseButton;

  csvFileTypes = [
    'text/comma-separated-values',
    'text/csv',
    'application/csv',
    'application/excel',
    'application/vnd.ms-excel',
    'application/vnd.msexcel',
    'text/anytext'
  ];

  constructor(private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit() {
  }

  fileEvent(event: any) {
    const file = event.target.files[0];
    if (file && this.csvFileTypes.includes(file.type)) {
      if (/[^-_.A-Za-z0-9]+/g.test(file.name)) {
        this.handleFailure('Upload a valid file of type csv');
      } else {
        this.file.emit(file);
      }
    } else {
      this.handleFailure('You can upload only csv files!');
    }
  }

  onclick(event) {
    if (this.preChange && !this.preChange()) { event.preventDefault(); }
    if (this.fileUploadInput) {
      this.fileUploadInput.nativeElement.value = '';
    }
  }

  handleFailure(error) {
    const criticalUploadKeymapFile: any = document.querySelector('#criticalUploadKeymapFile');

    criticalUploadKeymapFile.text = error;
    criticalUploadKeymapFile.open();

    this.changeDetectorRef.detectChanges();
    this.errorEventEmitter.emit();
  }
}
